import type { SVGProps } from "react";

export default function FilterIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.8333 1.5H3.16667C2.24619 1.5 1.5 2.24619 1.5 3.16667V4.14297C1.5 4.58501 1.67559 5.00893 1.98816 5.32149L6.84518 10.1785C7.15774 10.4911 7.33333 10.915 7.33333 11.357V15.6667V15.9047C7.33333 16.4319 7.97075 16.6959 8.3435 16.3232L9 15.6667L10.1785 14.4882C10.4911 14.1756 10.6667 13.7517 10.6667 13.3097V11.357C10.6667 10.915 10.8422 10.4911 11.1548 10.1785L16.0118 5.32149C16.3244 5.00893 16.5 4.58501 16.5 4.14297V3.16667C16.5 2.24619 15.7538 1.5 14.8333 1.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
